import React from 'react';
import { ChipComponent } from '../common/ChipComponent';
import { usePermissionWrapper } from '../common/hooks/usePermissionWrapper';
import { StackComponent } from '../common/StackComponent';
import { IDocument } from './types';

export interface IRecentDocuments {
  heading: string;
  items?: any;
  handleClick: (item: IDocument) => void;
}

export const RecentDocuments: React.FC<IRecentDocuments> = ({ heading, items, handleClick }) => {
  const { checkPermission } = usePermissionWrapper();
  return (
    <>
      <h4>{heading}</h4>
      <StackComponent direction="row" spacing={1} className="recent-docs-chips">
        {items &&
          items?.selected_data?.map((item: any, i: number) => (
            <ChipComponent
              key={i}
              label={item.document_data.isf_document_name}
              variant="outlined"
              item={item}
              handleClick={checkPermission('view_document_details') ? handleClick : undefined}
            />
          ))}
      </StackComponent>
    </>
  );
};
